import DOMPurify from 'isomorphic-dompurify';

/**
 * Defense-in-depth sanitizer for server-provided HTML rendered via
 * dangerouslySetInnerHTML (call pulses, email bodies, chat messages,
 * task descriptions).
 *
 * Intentionally permissive: preserves inline styles, tables, links,
 * images and data-* attributes so existing formatting is unchanged.
 * Its only job is stripping active content — <script>, event handlers
 * (onclick/onerror/...), javascript: URLs, and similar vectors.
 */
export function sanitizeHtml(html: string | null | undefined): string {
  if (!html) return '';
  return DOMPurify.sanitize(html, {
    USE_PROFILES: { html: true },
    ADD_TAGS: ['style'],
    ADD_ATTR: ['target'],
    ALLOW_DATA_ATTR: true,
  });
}
